var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFourSquaresIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58 0H12.34C15.16 0 17.42 2.3 17.42 5.122V11.94C17.42 14.78 15.16 17.06 12.34 17.06H5.58C2.78 17.06 0.5 14.78 0.5 11.94V5.122C0.5 2.3 2.78 0 5.58 0ZM5.58 22.9394H12.34C15.16 22.9394 17.42 25.2214 17.42 28.0614V34.8794C17.42 37.6994 15.16 39.9994 12.34 39.9994H5.58C2.78 39.9994 0.5 37.6994 0.5 34.8794V28.0614C0.5 25.2214 2.78 22.9394 5.58 22.9394ZM35.4202 0H28.6602C25.8402 0 23.5802 2.3 23.5802 5.122V11.94C23.5802 14.78 25.8402 17.06 28.6602 17.06H35.4202C38.2202 17.06 40.5002 14.78 40.5002 11.94V5.122C40.5002 2.3 38.2202 0 35.4202 0ZM28.6602 22.9394H35.4202C38.2202 22.9394 40.5002 25.2214 40.5002 28.0614V34.8794C40.5002 37.6994 38.2202 39.9994 35.4202 39.9994H28.6602C25.8402 39.9994 23.5802 37.6994 23.5802 34.8794V28.0614C23.5802 25.2214 25.8402 22.9394 28.6602 22.9394Z",
    fill: "url(#paint0_linear_157_2667)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_2667",
    x1: 40.5002,
    y1: 39.9994,
    x2: -7.0963,
    y2: 26.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246BFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5089FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourSquaresIcon);
export default __webpack_public_path__ + "static/media/FourSquaresIcon.31892ad989dd976c94e98948d4977d91.svg";
export { ForwardRef as ReactComponent };